<template>
  <div class="fotter row">
    <div class="footerbox">
      <div class="footcode">
        <a
          href="http://114.55.181.28/errorInfo/jcInfo/3ead4f5b-e5fe-4cea-92e3-9580c794f3ef-147672609"
          target="_blank"
        >
          <img src="../../assets/img/jiucuo.png">
        </a>
      </div>
      <div class="foottimg">
        主办：鄂尔多斯交通运输网 地址：鄂尔多斯市康巴什区国泰商务广场CBD办公区T2号楼7楼 
        <br>   
        电话：0477-8586809&nbsp;&nbsp;&nbsp;&nbsp;传真：0477-8586809&nbsp;&nbsp;&nbsp;&nbsp;蒙ICP17002409号—2&nbsp;&nbsp;&nbsp;&nbsp;网站标识码：1506000022
        <br>技术支持：北京易华录技术股份有限公司 &nbsp;
        <div style="width:300px;margin:0 auto; padding: 0;">
          <a
            target="_blank"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=15060302000173"
            style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"
          >
            <p
              style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;"
            >蒙公网安备 15060302000173号</p>
          </a>
        </div>
      </div>
      <div class="coad2">
        <a
          href="http://bszs.conac.cn/sitename?method=show&amp;id=1D15E2701DA53A46E053012819AC5D06"
          target="_blank"
        >
          <img src="../../assets/img/timg.png">
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "index",
  data() {
    return {};
  }
};
</script>
<style scoped>
.footerbox {
  width: 100%;
  margin: 0 auto;
  padding: 15px 20px 15px 60px;
  box-sizing: border-box;
  overflow: hidden;
  background: #eee;
}

.coad2 {
  overflow: hidden;
  width: 10%;
  float: left;
}

.footcode {
  overflow: hidden;
  width: 10%;
  float: left;
}
.footcode p {
  padding: 10px 0;
  margin: 0;
  line-height: 24px;
  font-size: 14px;
}

.footcode img {
  padding-top: 5px;
}

.foottimg {
  font-size: 14px;
  overflow: hidden;
  width: 80%;
  float: left;
  text-align: center;
}
.foottimg p {
  padding: 2px 0;
  margin: 0;
  line-height: 24px;
  font-size: 14px;
}

.foottimg img {
  vertical-align: top;
}
.foottimg a {
  color: #000;
}
</style>


// WEBPACK FOOTER //
// src/components/footer/index.vue